<header class="pc-header">
  <h1 class="pc-header__title">
    PALCHAT
    <span class="pc-header__badge">AI assistant</span>
  </h1>
  @if (embedBridge.$isEmbedded()) {
    <div class="pc-header__actions">
      <button
        type="button"
        class="pc-header__action"
        [attr.aria-label]="
          embedBridge.$size() === 'expanded' ? 'Shrink chat' : 'Expand chat'
        "
        (click)="embedBridge.toggleExpanded()"
      >
        <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
          @if (embedBridge.$size() === 'expanded') {
            <path
              d="M22 3.41 16.71 8.7 20 12h-8V4l3.29 3.29L20.59 2 22 3.41zM3.41 22l5.29-5.29L12 20v-8H4l3.29 3.29L2 20.59 3.41 22z"
            />
          } @else {
            <path d="M21 11V3h-8l3.29 3.29-10 10L3 13v8h8l-3.29-3.29 10-10z" />
          }
        </svg>
      </button>
      <button
        type="button"
        class="pc-header__action"
        [attr.aria-label]="
          embedBridge.$size() === 'full' ? 'Exit full screen' : 'Full screen'
        "
        (click)="embedBridge.toggleFullScreen()"
      >
        <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
          @if (embedBridge.$size() === 'full') {
            <path
              d="M5 16h3v3h2v-5H5v2zm3-8H5v2h5V5H8v3zm6 11h2v-3h3v-2h-5v5zm2-11V5h-2v5h5V8h-3z"
            />
          } @else {
            <path
              d="M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z"
            />
          }
        </svg>
      </button>
      <button
        type="button"
        class="pc-header__action"
        aria-label="Close chat"
        (click)="embedBridge.requestClose()"
      >
        <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
          <path
            d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
          />
        </svg>
      </button>
    </div>
  }
</header>

<div class="pc-body">
  <copilot-chat
    [agentId]="agentId"
    [messageViewChildrenComponent]="statusComponent"
    [inputComponent]="chatInputComponent"
    class="pc-chat"
  />
</div>
